import { io } from 'socket.io-client';

const BACK_END_URL =
  import.meta.env.WEBSITE_BACKEND_URL || 'http://localhost:1337';

export const socket = io(BACK_END_URL, { autoConnect: false });
